<template>
  <base-card :loading="loading" class="rounded-lg">
    <party-header-navigation-bar :party="party" type="details" />
    <v-tabs v-model="tab" show-arrows class="rounded-t-lg" height="36px">
      <v-tab
        v-for="tab in !party ? [] : tabsFiltered"
        class="rounded-t-lg"
        :key="tab.component"
      >
        <v-icon left small>{{ tab.icon }}</v-icon>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      class="rounded-b-xl"
      :touchless="tabsFiltered[tab]?.touchless"
    >
      <v-tab-item v-for="item in !party ? [] : tabsFiltered" :key="item.name">
        <component
          :is="item.component"
          :party="party"
          :loading="loading"
          @refresh="getParty"
          class="px-4 pb-4"
        />
      </v-tab-item>
    </v-tabs-items>

    <tecnician-daily :party="party" />

    <!-- Navgation  -->
    <PartyBottomSheetNavigation group="details" :party="party" />
  </base-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PartyDetails from "@/components/admin/party/PartyDetails";
import PartyPolicies from "@/components/admin/party/PartyPolicies";
import PartyAttractions from "@/components/admin/party/PartyAttractions.vue";
import PartyRating from "@/components/admin/party/PartyRating.vue";
import PartyGallery from "@/components/admin/party/PartyGallery.vue";
import PartyPrintConfigurator from "@/components/admin/party/PartyPrintConfigurator.vue";
import PartyPeriod from "@/components/admin/party/PartyPeriod.vue";
import PartyFaq from "@/components/admin/party/PartyFaq.vue";
import PartyMap from "@/components/admin/party/PartyMap.vue";
// import PartyProductUpsell from "@/components/admin/party/PartyProductUpsell.vue";
import PartyWhatsappGroup from "@/components/admin/party/PartyWhatsappGroup.vue";
import PartyTableMap from "@/components/admin/party/PartyTableMap.vue";
import PartyCoOrganizer from "@/components/admin/party/PartyCoOrganizer.vue";
import PartyBanners from "@/components/admin/party/detailsComponents/Banners.vue";
import PartyRiskOperations from "@/components/admin/party/detailsComponents/PartyRiskOperations.vue";
import TecnicianDaily from "@/components/global/tecnician/TecnicianDaily.vue";
import PartyHeaderNavigationBar from "./modules/PartyHeaderNavigationBar.vue";
import partyTabs from "@/definitions/partyTabs";
import PartyBottomSheetNavigation from "@/components/admin/party/PartyBottomSheetNavigation.vue";

export default {
  metaInfo() {
    return { title: `ℹ️ ${this.party?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    tab: null,
    navigationSheet: false,
    tabs: partyTabs.details,
  }),
  methods: {
    ...mapActions("organization", { updateParty: "partyById" }),
    async getParty() {
      try {
        this.selectTab();
        this.loading = true;
        await this.updateParty(this.$route.params.partyId);
        this.loading = false;
        this.$root.$emit("setImgBg", this.party?.cover);
      } catch (error) {
        console.error(error);
        console.log(this.$route);
        debugger;
        this.$router.push({ name: "admin.parties" });
      }
    },
    selectTab() {
      if (this.$route.hash) {
        let hash = this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  destroyed() {
    this.$root.$emit("setImgBg", null);
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("organization", { getPartyById: "partyById" }),
    ...mapGetters("auth", ["hasPermission"]),
    party() {
      return this.getPartyById(this.$route.params.partyId);
    },
    tabsFiltered() {
      return this.tabs.filter((tab) => {
        if (this.party?.isFree && tab.noFree) return false;
        if (!tab.permission) return true;
        return this.hasPermission(tab.permission);
      });
    },
    tabsNavigation() {
      return this.tabsFiltered.filter((tab) => !tab.hideFromNavigation);
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "$route.params.partyId"() {
      this.getParty();
    },
    "selectedOrganization.id"() {
      this.$router.push({
        name: "admin.parties",
      });
    },
  },
  components: {
    TecnicianDaily,
    PartyDetails,
    PartyAttractions,
    PartyRating,
    PartyGallery,
    PartyPrintConfigurator,
    PartyPeriod,
    PartyFaq,
    PartyPolicies,
    PartyMap,
    PartyTableMap,
    PartyCoOrganizer,
    PartyWhatsappGroup,
    // PartyProductUpsell,
    PartyBanners,
    PartyRiskOperations,
    PartyHeaderNavigationBar,
    PartyBottomSheetNavigation,
  },
  mounted() {
    this.getParty();
  },
};
</script>

<style></style>
